import React, { useRef, useState } from 'react';
import { Button, Dialog, DialogContent, DialogActions, CircularProgress } from '@mui/material';
import StandardDialogHeader from '../StandardComponents/StandardDialog/StandardDialogHeader';
import { DIALOG_PAPER_SX, DIALOG_CONTENT_SX, DIALOG_ACTIONS_SX } from './dialogStyles';
import EntitlementCodeModal from './EntitlementCodeModal';

/**
 * EntitlementCodeDialog — create/edit unlock codes.
 * Renders EntitlementCodeModal eagerly (not via StandardFormView lazy Suspense),
 * which avoids a perpetual spinner if the form chunk stalls.
 */
export default function EntitlementCodeDialog({ open, mode = 'create', code, onClose, onSaved }) {
  const isEdit = mode === 'edit';
  const formRef = useRef(null);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!formRef.current?.saveData) return;
    setSaving(true);
    try {
      await formRef.current.saveData();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={saving ? undefined : onClose}
      maxWidth={false}
      PaperProps={{ sx: DIALOG_PAPER_SX }}
    >
      <StandardDialogHeader
        title={isEdit ? 'Edit Unlock Code' : 'Create Unlock Code'}
        onClose={saving ? undefined : onClose}
      />
      <DialogContent sx={DIALOG_CONTENT_SX}>
        {open && (
          <EntitlementCodeModal
            ref={formRef}
            flag={isEdit ? 'edit' : 'add'}
            editItems={isEdit ? code : null}
            onClose={onClose}
            getAllData={onSaved}
          />
        )}
      </DialogContent>
      <DialogActions sx={DIALOG_ACTIONS_SX}>
        <Button onClick={onClose} className="global-text-button" disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          className="global-primary-button"
          onClick={handleSave}
          disabled={saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {isEdit ? 'Save Changes' : 'Create Code'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
